import { useSelector } from "react-redux";
import { AppState } from "../../../core/app/AppReducer";
import KokiriBoots from "../../../core/assets/oot/gshd/kokiri-boots_32x32.png";
import Item from "../../../core/items/Item";
import OotItem from "./OotItem";


const KokiriBootsItem = () => {

    let id = "OoT_KokiriBoots";

    let reduce = useSelector((state: AppState) => state.ui.ootr.main.useItemTrackerReduce)

    if (reduce)
        return null;

    return <OotItem id={id}>
        {({ updateOotItem, item }) => {
            return <Item id={id} image={KokiriBoots} title="Kokiri Boots" updateItem={updateOotItem} item={item} isObtained={true}
            />
        }}</OotItem>
}

export default KokiriBootsItem;


export const SimpleKokiriBootsItem = () => {


    return <Item
        image={KokiriBoots}
        isObtained={true}
        id={"Kokiri Boots"}
        onClick={() => { }}
        title="Kokiri Boots"
    />


}